// App configuration - single source of truth
export const APP_VERSION = "v3.0.26";
export const BUILD_DATE = "2026-07-15";
